import { A } from '@solidjs/router';
import { type JSX, Match, Switch } from 'solid-js';
import { t } from '../i18n';
import { machineAccess } from '../lib/fleet-machine-panel';
import type { UtilBox } from '../lib/fleetUtilization';
import { orgHref } from '../lib/org';

// What the details panel says in place of its Actions when the viewer may not act
// (#6563): a member or viewer reads that only admins can (owner ruling G21); a machine
// from another org is read-only for everyone here and is managed in its own org, with a
// link that switches to it and opens the same machine there (G23).

export function MachinePanelAccess(props: {
  readonly box: UtilBox;
  readonly canWrite: boolean;
}): JSX.Element {
  const access = () => machineAccess(props.box, props.canWrite);
  const otherOrg = () => {
    const a = access();
    return a.kind === 'other_org' ? a.org : null;
  };
  return (
    <section class="machine-panel__section" aria-labelledby="machine-panel-actions">
      <h3 id="machine-panel-actions" class="machine-panel__h3">
        {t('fleet.panel.actions')}
      </h3>
      <Switch>
        <Match when={otherOrg()}>
          {(org) => (
            <p class="machine-panel__muted">
              {t('fleet.panel.other_org', { org: org() })}{' '}
              <A href={orgHref(`/fleet?machine=${encodeURIComponent(props.box.id)}`, org())}>
                {t('fleet.panel.switch_org', { org: org() })}
              </A>
            </p>
          )}
        </Match>
        <Match when={access().kind === 'member'}>
          <p class="machine-panel__muted">{t('fleet.panel.members_only')}</p>
        </Match>
      </Switch>
    </section>
  );
}
